import React from 'react';
import { Link } from '@mui/material';
// @ts-ignore
import logotype from '@app/assets/ok-telecom-black.png';
import { LogoImage } from '@app/ui/pages/landing-page/header/logo/logo.styles';
import { LogoProps } from '@app/ui/pages/landing-page/header/logo/logo.types';

export const Logo: React.FC<LogoProps> = (props) => {
  const { href = '/' } = props;

  return (
    <Link href={href}>
      <LogoImage src={logotype} />
    </Link>
  );
};
